<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/packing_by_pallet/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-pallet-box"></i><span class="space-icon"></span>
      {{ $t("labels.package_groups_from_stock_title") }}
    </h1>

    <div class="mt-4 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="`${getFormatNumber(total_rows)} ${$t(
            'labels.total_package_groups_from_stock'
          )}`"
        />
      </div>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="width: 100%; height: 600px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="package_groups_from_stock"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="Number(total_rows) > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/show_process.js";

import { AgGridVue } from "ag-grid-vue3";
import { dateFilter } from "@/components/views/mixins/ag_grid_filters.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "PHProductionPackingByPalletShowProcessPackageGroupsFromStock",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      package_groups_from_stock: [],
      total_rows: 0,
      current_page: 1,
      rows_per_page: 12,
      columnDefs: [
        {
          headerName: this.$t("model.package_group.pg_code"),
          field: "pg_code",
          filter: true,
        },
        {
          headerName: this.$t("model.package_group.grouped_at"),
          valueGetter: (params) => {
            return params.data.grouped_at;
          },
          valueFormatter: (params) => {
            return this.dateFormatter(params.data.grouped_at);
          },
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.package_group.total_packages"),
          field: "total_packages",
          filter: "agNumberColumnFilter",
        },
        {
          headerName: this.$t("model.package_group.comment"),
          field: "comment",
          flex: 2,
        },
      ],
    };
  },
  props: {
    packing_house_id: {},
    packing_house_process_id: {},
  },
  watch: {
    current_page: function () {
      this.fetchPackageGroupsFromStock();
    },
  },
  methods: {
    fetchPackageGroupsFromStock: async function () {
      const response = await Requester.fetchPackageGroupsFromStock(
        this.packing_house_id,
        this.packing_house_process_id,
        this.current_page,
        this.rows_per_page
      );

      this.total_rows = response.data.total_rows;
      this.package_groups_from_stock = response.data.records;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },
    defaultColDef() {
      return { sortable: true, filter: true, floatingFilter: true };
    },
  },
  created() {
    this.fetchPackageGroupsFromStock();
  },
};
</script>
